import moment from "moment";
import type { AuditFooterItem, AuditMetricRowData } from "../types/auditMetrics";

export const AUDIT_DAY_PROGRESS_LABEL = "DAY IN PROGRESS";

export const isAuditDayInProgress = (reportDate?: string | null) => {
  if (!reportDate) {
    return false;
  }

  const parsedReportDate = moment(reportDate, "YYYY-MM-DD", true);
  return parsedReportDate.isValid() && parsedReportDate.isSame(moment(), "day");
};

interface DayInProgressMetricRowOptions {
  preserveScratcherExpectedValues?: boolean;
}

const isScratcherExpectedValueRow = (row: AuditMetricRowData) =>
  row.id.includes("scratcher-qty") || row.id.includes("scratcher-sales");

export const buildDayInProgressMetricRows = (
  rows: AuditMetricRowData[],
  options: DayInProgressMetricRowOptions = {}
): AuditMetricRowData[] => {
  return rows.map((row) => ({
    ...row,
    expected:
      options.preserveScratcherExpectedValues && isScratcherExpectedValueRow(row)
        ? row.expected
        : "-",
    reported: "-",
    variance: "-",
    tone: "progress",
    trailingNote: row.trailingNote ? "Scratcher Audit Window: -" : row.trailingNote,
  }));
};

export const buildDayInProgressFooterItems = (items: AuditFooterItem[]): AuditFooterItem[] => {
  return items.map((item) => ({
    ...item,
    value: "-",
    tone: "progress",
  }));
};
